import { render, staticRenderFns } from "./footerBottom.vue?vue&type=template&id=bf896980&scoped=true&"
import script from "./footerBottom.vue?vue&type=script&lang=js&"
export * from "./footerBottom.vue?vue&type=script&lang=js&"
import style0 from "./footerBottom.vue?vue&type=style&index=0&id=bf896980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf896980",
  null
  
)

export default component.exports